import { Box } from 'components/Material/Box'
import { Progress } from '../Progress'

const LoadingPage = () => {
  return (
    <Box className="w-full h-screen flex justify-center items-center">
      <Progress />
    </Box>
  )
}

export default LoadingPage
